import React from "react";
import Skeleton from "react-loading-skeleton";
import type { TransformedProduct } from "../../types/productApiTypes";
import ProductCard from "./ProductCard";

interface ProductsDisplayProps {
  products: TransformedProduct[];
  isLoading: boolean;
  isFetching: boolean;
  error?: any; // Consider a more specific error type
  activeView: "grid" | "list"; // Add activeView prop
}

const ProductsDisplay: React.FC<ProductsDisplayProps> = ({
  products,
  isLoading,
  isFetching,
  error,
  activeView, // Destructure activeView
}) => {
  if (error) {
    return (
      <div className="products-display-error">
        <p>Error loading products. Please try again later.</p>
      </div>
    );
  }

  const viewClass = activeView === "grid" ? "products-grid" : "products-list";

  if (isLoading) {
    // Initial load: show skeleton
    const skeletonContainerClass = `${viewClass} loading`;
    return (
      <div className={skeletonContainerClass}>
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="product-card-skeleton">
            <Skeleton height={200} />
            <Skeleton count={1} style={{ marginTop: "10px" }} />
            <Skeleton width="60%" style={{ marginTop: "5px" }} />
          </div>
        ))}
      </div>
    );
  }

  // Subsequent fetches or no products
  const displayClassName = `${viewClass} ${
    isFetching ? "is-fetching" : ""
  }`.trim();

  if (!products || products.length === 0) {
    // Note: .products-grid-empty styles will apply if activeView is 'grid'.
    // For 'list' view, a .products-list-empty style might be needed later.
    return (
      <div
        className={
          activeView === "grid" ? "products-grid-empty" : "products-list-empty"
        }
      >
        <p>Ürün bulunamadı.</p>
      </div>
    );
  }

  return (
    <div className={displayClassName}>
      {isFetching && <div className="products-display-overlay"></div>}
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          viewMode={activeView} // Pass activeView as viewMode
        />
      ))}
    </div>
  );
};

export default ProductsDisplay;
